(function () {
	'use strict';

	angular.module('mx.components').factory('mx.components.TinymceUtils', [
		'mx.internationalization',
		'mx.shell.Config',
		function tinymceUtils(mxI18n, mxConfig) {
			return {
				getMceI18nOptions: getMceI18nOptions,
				extendMissingI18n: extendMissingI18n,
			};

			function getMceI18nOptions() {
				const lang2Letters = (mxI18n.language || 'en').substring(0, 2).toLowerCase();
				const localeID = mxI18n.getLocale().localeID;
				// if 'en' - do nothing, because it's by default
				if (localeID === 'en_US') {
					return {};
				}
				var langSufix = '';
				var availableMceI18n = [
					'af_ZA',
					'ar',
					'az',
					'be',
					'bg_BG',
					'bn_BD',
					'ca',
					'cs',
					'cs_CZ',
					'cy',
					'da',
					'de',
					'de_AT',
					'dv',
					'el',
					'en_GB',
					'en_CA',
					'es',
					'es_MX',
					'et',
					'eu',
					'fa_IR',
					'fi',
					'fr_FR',
					'ga',
					'gl',
					'he_IL',
					'hr',
					'hu_HU',
					'id',
					'it',
					'ja',
					'ka_GE',
					'kab',
					'kk',
					'km_KH',
					'ko_KR',
					'lt',
					'lv',
					'nb_NO',
					'nl',
					'pl',
					'pt_PT',
					'pt_BR',
					'ro',
					'ru',
					'sk',
					'sl_SI',
					'sr',
					'sv_SE',
					'ta',
					'ta_IN',
					'th_TH',
					'tr',
					'tr_TR',
					'ug',
					'uk',
					'uk_UA',
					'uz',
					'vi_VN',
					'zh_CN',
					'zh_TW',
				];

				if (availableMceI18n.indexOf(localeID) !== -1) {
					langSufix = localeID;
				} else if (availableMceI18n.indexOf(lang2Letters) !== -1) {
					langSufix = lang2Letters;
				} else {
					langSufix = availableMceI18n.find((code) => code.indexOf(lang2Letters + '_') === 0);
				}

				return langSufix ? { language: langSufix, language_url: mxConfig.settings.basePath + 'node_modules/tinymce-i18n/langs/' + langSufix + '.js' } : {};
			}

			function extendMissingI18n(editor) {
				if (editor.settings.language && editor.settings.language.indexOf('en') !== 0) {
					editor.editorManager.addI18n(editor.settings.language, {
						'Insert/edit media': mxI18n.get('solutionBuilderAgent.components.tinyMCE.insertEditMedia'),
						'Table of Contents': mxI18n.get('solutionBuilderAgent.components.tinyMCE.tableOfContents'),
						'Insert/Edit code sample': mxI18n.get('solutionBuilderAgent.components.tinyMCE.codeSampleBtn'),
					});
				}
			}
		},
	]);
})();
